import { render, staticRenderFns } from "./RoleBasedDashboard.vue?vue&type=template&id=0f586672&scoped=true"
import script from "./RoleBasedDashboard.vue?vue&type=script&lang=js"
export * from "./RoleBasedDashboard.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedDashboard.vue?vue&type=style&index=0&id=0f586672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f586672",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
